import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import { convertToMask } from '../../../utils/common';

import {
  setConferenceDetail,
  useCallNumber,
  useConferenceDetail
} from '../../../store/slices/dialSlice';
import { useUserDetails } from '../../../store/slices/authSlice';
import { useCallingData } from '../../Context/CallingContext';
import { handleConference } from '../../../store/slices/callingSlice';

const ConferenceCallDetail = ({ isLoading = false, number }) => {
  const dispatch = useDispatch();

  const conferenceDetail = useConferenceDetail();
  const user = useUserDetails();
  const callNumber = useCallNumber();

  const { mutedConference, setMutedConference } = useCallingData();

  const handleConferenceMode = async (conf_id, type) => {
    try {
      const payload = {
        conf_id: conf_id,
        type: type,
        conf_name: conferenceDetail?.conference_name
      };
      await dispatch(handleConference(payload)).unwrap();
      if (type === 'hangup') {
        if (conferenceDetail?.details) {
          const updatedDetails = conferenceDetail.details.filter(
            (detail) => detail.conf_id !== conf_id
          );
          dispatch(
            setConferenceDetail({
              ...conferenceDetail,
              details: updatedDetails
            })
          );
        }
      } else {
        setMutedConference((prev) =>
          prev.includes(conf_id) ? prev.filter((id) => id !== conf_id) : [...prev, conf_id]
        );
      }
    } catch (error) {
      console.log('error', error);
    }
  };

  return (
    <div className="mt-auto mb-auto text-white fw-bold fs-4 d-flex justify-content-center align-items-start flex-column">
      {[...(conferenceDetail?.details || [])]
        ?.slice()
        ?.sort((a, b) => {
          const getPriority = (x) => {
            if (x?.number === user?.username) return 1;
            if (String(x?.number) === String(callNumber || number)) return 2;
            return 3;
          };
          return getPriority(a) - getPriority(b);
        })
        ?.map((x, index) => (
          <div key={index} className="d-flex justify-content-between w-100 pb-1">
            {user?.process_details?.numberMasking === 'true' ? convertToMask(x?.number) : x?.number}
            <div className="d-flex align-content-center gap-3 justify-content-start">
              <div
                onClick={() =>
                  handleConferenceMode(
                    x?.conf_id,
                    mutedConference.includes(x?.conf_id) ? 'unmute' : 'mute'
                  )
                }>
                <i
                  className={`bi ${mutedConference.includes(x?.conf_id) ? 'bi-mic-mute-fill' : 'bi-mic-fill'} fs-5 cursor-pointer`}
                />
              </div>
              <div
                onClick={() => {
                  if (x?.number !== user?.username) {
                    handleConferenceMode(x?.conf_id, 'hangup');
                  }
                }}>
                <i
                  className={`bi bi-telephone-x-fill fs-5 text-danger ${x?.number !== user?.username ? 'cursor-pointer' : 'opacity-0'}`}
                />
              </div>
            </div>
          </div>
        ))}
      {isLoading ? <div className="text-lightGray fs-6">Connecting...</div> : null}
    </div>
  );
};

ConferenceCallDetail.propTypes = {
  isLoading: PropTypes.bool,
  number: PropTypes.string
};

export default ConferenceCallDetail;
